/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { message } from 'ant-design-vue';
import router from '@/router/index';

let baseURL: any = '/api',
    baseLandUrl: any = '/land';

if (process.env.NODE_ENV === 'production') {
    // 生产环境逻辑
    // baseURL = 'http://172.19.61.64:8181';
    baseURL = process.env.VUE_APP_URL;
    baseLandUrl = 'http://land.choiceshine.cn';
} else {
    // 开发环境逻辑
    baseURL = '/api';
    baseLandUrl = '/land';
}

const request = axios.create({
    baseURL: baseURL,
    timeout: 600000, // 请求超时时间
});

// 请求拦截器
request.interceptors.request.use((config: any) => {
    // 关键：根据 config.url 判断使用哪个 baseURL
    if (config.url && config.url.startsWith('/land')) config.baseURL = baseLandUrl;
    else config.baseURL = baseURL;
    // 可以在这里添加例如token等请求头
    config.headers['Authorization'] = localStorage.getItem('token');
    config.headers['token'] = localStorage.getItem('token');
    if (config.method == 'get') {
        // console.log(config)
    } else {
        // console.log(config)
    }
    return config;
}, (error: any) => {
    // 请求错误处理
    return Promise.reject(error);
});

// 响应拦截器
request.interceptors.response.use((response: any) => {
    // 对响应数据做处理，例如只返回data部分
    if (response.config.responseType == 'blob') {
        if (response.status == 200) {
            return response.data;
        } else {
            message.error(response.data.msg);
            return response.data;
        }
    } else if (response.data.code == 0) {
        return response.data;
    } else if (response.data.code == 1000) {
        localStorage.removeItem('token');
        router.replace('/login');
        return response.data;
    } else if (response.data.code == 1200) {
        router.replace('/noPermission');
        return response.data;
    } else if (response.data.code == 2000) {
        message.error(response.data.msg);
        setTimeout(() => {
            location.reload();
        }, 3000);
        return response.data;
    } else {
        message.error(response.data.msg);
        return response.data;
    }
}, (error: any) => {
    // 响应错误处理
    return Promise.reject(error);
});

export default request;